import React from 'react';
import { TWhatsNewNotification } from 'lendingApi/whatsNew';
import { SideItem } from './SideItem/SideItem';
import styles from './SideList.module.css';

type TProps = {
  onSelectContent: (contentId: string) => void;
  selectedContentId: string | null;
  data: TWhatsNewNotification[];
  listRef?: React.RefObject<HTMLDivElement>;
};

export const SideList = ({
  data,
  selectedContentId,
  onSelectContent,
  listRef,
}: TProps) => {
  return (
    <div ref={listRef} className={styles.sideListWrapper}>
      <div className={styles.sideList}>
        {data.map((content) => (
          <SideItem
            key={content.id}
            data={content}
            onClick={onSelectContent}
            isSelected={selectedContentId === content.id}
          />
        ))}
      </div>
    </div>
  );
};
